import React from "react"

const LMainBackgroundLines = () => {
  return (
    <div className="main-back-lines">
      <div className="inner" />
    </div>
  )
}

export default LMainBackgroundLines
